import React from 'react';
import PropTypes from 'prop-types';

import {useLocation} from 'react-router-dom';

import {dispatch, connect} from 'utils/state_manager';

import {Box} from 'views/components';

import NavbarService from './NavbarService';

const NavbarServices = (props) => {
  const services = props.services;

  const location = useLocation();

  return (
    <Box sx={{pt: 1}}>
      {
        services.map((e, index) => {
          return (
            <Box
              key={index}
            >
              <NavbarService
                selected={e.isActive(location.pathname)}
                title={e.title}
                link={e.link}
                options={Object.values(e.options)}
                icon={e.icon}
              />
            </Box>
          );
        })
      }
    </Box>
  );
};
NavbarServices.propTypes = {
  services: PropTypes.array.isRequired,
};
const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(NavbarServices));
